import './Footer.css'


const Footer = ()=>{
    return(

        <div className='Footer-container  '>

            <div className='wave-container'></div>
            <div className='footer-wrapper'>
                <div className='row'>
                    <div className='footer-col'>
                        <h4>Community</h4>
                        <ul>
                            <li><a href='/'>© copyright 2023, Ghana biochemistry students' association</a></li>
                            <li><a href='/AboutUs'>About us</a></li>
                            <li><a href='/Contact-us'>Contact us</a></li>
                            <li><a href='/privacy-policy'>Privacy Policy</a></li>
                        </ul>
                    </div>
                    
                    <div className='footer-col'>
                        <h4>Shortcuts</h4>
                        <ul>
                            
                            <li><a href='/admin/loginX'>Administrator</a></li>
                            {/*<li><a href='#'>Alumni</a></li>*/}
                            
                        </ul>
                    </div>
                    
                </div>
            </div>
            <span className='center'>Developed by chillin wif dinitrophenol <span className="heart">❤️</span> </span>
        </div>

    )
}
export default Footer;